document.addEventListener('DOMContentLoaded', function () {
  const showVideoUnavailableMessage = () => {
    const embedDiv = document.querySelector('.editoriumVideoCard__embed')
    if (!embedDiv) return

    const iframe = embedDiv.querySelector('iframe')
    if (iframe?.hasAttribute('src')) return

    if (!embedDiv.querySelector('.videoUnavailableMessage')) {
      const messageDiv = document.createElement('div')
      messageDiv.className = 'videoUnavailableMessage'
      messageDiv.innerHTML = window.I18n.videoUnavailable
      embedDiv.appendChild(messageDiv)
    }
  }

  const removeVideoUnavailableMessage = () => {
    const embedDiv = document.querySelector('.editoriumVideoCard__embed')
    const messageDiv = embedDiv?.querySelector('.videoUnavailableMessage')
    if (messageDiv) {
      messageDiv.remove()
    }
  }

  const checkMarketingStatus = () => {
    if (typeof OptanonActiveGroups !== 'undefined') {
      const hasMarketingConsent = OptanonActiveGroups.includes('C0004')

      if (!hasMarketingConsent) {
        showVideoUnavailableMessage()
      } else {
        removeVideoUnavailableMessage()
      }
    }
  }

  window.addEventListener('OneTrustGroupsUpdated', function () {
    checkMarketingStatus()
  })

  // Prevent default behavior for OneTrust settings links, but allow OneTrust to handle click
  document.addEventListener(
    'click',
    function (e) {
      const linkElement = e.target.closest('.ot-sdk-show-settings')
      if (linkElement) {
        e.preventDefault()
      }
    },
    true,
  )

  // Initial fallback check
  setTimeout(checkMarketingStatus, 0)
})
